module.exports = __webpack_public_path__ + "img/ic24ViewOnRed.ad3372f3.svg";